/* 
  =============================================
              GRIFF - Custom JS
  =============================================
*/


/* HEADER */




/* LAYOUT */

/* Back To Top Button */
const backToTopButton = document.querySelector('.back-to-top');

backToTopButton.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});